import React, { useEffect } from 'react';

interface FacebookCommentsProps {
  url: string;
  enabled: boolean;
  width?: number;
  facebookCommentCode?: string;
}

export const FacebookComments: React.FC<FacebookCommentsProps> = ({ 
  url, 
  enabled,
  width = 800,
  facebookCommentCode
}) => {
  useEffect(() => {
    if (!enabled) return;

    // Load Facebook SDK
    if (!(window as any).FB) {
      const script = document.createElement('script');
      script.src = 'https://connect.facebook.net/vi_VN/sdk.js#xfbml=1&version=v18.0';
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      document.body.appendChild(script);

      script.onload = () => {
        if ((window as any).FB) {
          (window as any).FB.XFBML.parse();
        }
      };
    } else {
      // Re-parse if FB SDK already loaded
      (window as any).FB.XFBML.parse();
    }
  }, [enabled, url]);

  if (!enabled) return null;

  return (
    <div className="mt-12 pt-8 border-t border-gray-200">
      <div className="flex items-center gap-2 mb-6">
        <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
        <h3 className="text-xl font-bold text-gray-900">Bình luận qua Facebook</h3>
      </div>
      
      <div className="bg-gray-50 p-4 rounded-lg">
        <div 
          className="fb-comments" 
          data-href={url}
          data-width={width}
          data-numposts="10"
          data-order-by="reverse_time"
          data-colorscheme="light"
        />
      </div>
    </div>
  );
};

export default FacebookComments;
